import { requireActiveOrg } from '../lib/config'
import { FlightDeskAPI } from '../lib/api'

interface StatusOptions {
  project?: string
}

export async function statusCommand(options: StatusOptions): Promise<void> {
  const { config, org } = requireActiveOrg()
  const api = FlightDeskAPI.fromConfig(config, org)

  try {
    const tasks = await api.listTasks({ projectId: options.project })

    if (tasks.length === 0) {
      console.log('No tasks found.')
      return
    }

    // Group tasks by status
    const byStatus: Record<string, typeof tasks> = {}
    for (const task of tasks) {
      if (!byStatus[task.status]) {
        byStatus[task.status] = []
      }
      byStatus[task.status].push(task)
    }

    // Status order for display
    const statusOrder = [
      'PENDING',
      'DISPATCHED',
      'IN_PROGRESS',
      'BRANCH_CREATED',
      'PR_OPEN',
      'PREVIEW_STARTING',
      'PREVIEW_READY',
      'REVIEW_RUNNING',
      'REVIEW_DONE',
      'QA_READY',
      'QA_APPROVED',
      'MERGED',
      'ARCHIVED',
    ]

    console.log('\n📋 FlightDesk Tasks\n')

    for (const status of statusOrder) {
      const statusTasks = byStatus[status]
      if (!statusTasks || statusTasks.length === 0) continue

      console.log(`${getStatusEmoji(status)} ${status} (${statusTasks.length})`)
      for (const task of statusTasks) {
        console.log(`   ${task.id.slice(0, 8)} - ${task.title}`)
        if (task.branchName) {
          console.log(`            Branch: ${task.branchName}`)
        }
        if (task.prUrl) {
          console.log(`            PR: ${task.prUrl}`)
        }
      }
      console.log('')
    }
  } catch (error) {
    console.error(`Error: ${error}`)
    process.exit(1)
  }
}

function getStatusEmoji(status: string): string {
  switch (status) {
    case 'PENDING':
      return '⬜'
    case 'DISPATCHED':
      return '🚀'
    case 'IN_PROGRESS':
      return '🔄'
    case 'BRANCH_CREATED':
      return '🌿'
    case 'PR_OPEN':
      return '📝'
    case 'PREVIEW_STARTING':
      return '⏳'
    case 'PREVIEW_READY':
      return '🌐'
    case 'REVIEW_RUNNING':
      return '🔍'
    case 'REVIEW_DONE':
      return '✅'
    case 'QA_READY':
      return '🧪'
    case 'QA_APPROVED':
      return '👍'
    case 'MERGED':
      return '🎉'
    case 'ARCHIVED':
      return '📦'
    default:
      return '❓'
  }
}
